export function pushError(topic, exception) {
  var xhttp = new XMLHttpRequest();
  xhttp.open(
    'POST',
    location.origin + '/index.php?frame=mail_error&TOPIC=' + topic,
    true,
  );
  xhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

  function replaceErrors(key, value) {
    if (value instanceof Error) {
      var error = {};

      Object.getOwnPropertyNames(value).forEach(function (propName) {
        error[propName] = value[propName];
      });

      return error;
    }

    return value;
  }

  var errorPackage = { renderCtrItemIsNull: true };

  if (window.currentPage != undefined) {
    try {
      errorPackage.reactUrl =
        window.historyHelper.memory.location.pathname +
        '?' +
        window.historyHelper.memory.location.search;
    } catch {}
    try {
      errorPackage.apidata = window.currentPage.state.apiData;
    } catch {}
  } else if (window.ctrlBackup != null) {
    errorPackage.renderCtrItemIsNull = false;
    errorPackage.reactUrl = window.ctrlBackup.reactUrl;
    errorPackage.apidata = window.ctrlBackup.apidata;
  }

  if (errorPackage.apidata != undefined) {
    errorPackage.apidata.cookieConfig = '!!!_REMOVED_!!!';
    errorPackage.apidata.footerLinks = '!!!_REMOVED_!!!';
  }

  errorPackage.userAgent = navigator.userAgent;

  errorPackage.error = exception;

  if (process.env.CI_PIPELINE_ID != null)
    errorPackage.version = '#' + process.env.CI_PIPELINE_ID;

  var errorMessage = JSON.stringify(errorPackage, replaceErrors);
  xhttp.send(errorMessage);
}
